import AnimatedSection from "../ui/AnimatedSection";
import { services } from "../../data/portfolioData";
import { useInView } from "../../hooks/useInView";

function ServiceCard({ service, index }) {
  const [ref, isVisible] = useInView();

  return (
    <div
      ref={ref}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "none" : "translateY(30px)",
        transition: `opacity 0.7s ease ${index * 120}ms, transform 0.7s ease ${index * 120}ms`,
      }}
      className="group p-8 border border-carbon-800 hover:border-ember-400/40 bg-carbon-900 hover:bg-carbon-800 transition-all duration-500 relative overflow-hidden"
    >
      {/* Hover glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-ember-400/0 to-ember-400/0 group-hover:from-ember-400/5 group-hover:to-transparent transition-all duration-500 pointer-events-none" />

      {/* Number */}
      <div className="absolute top-6 right-6 font-display text-6xl text-carbon-800 group-hover:text-carbon-700 transition-colors duration-300 leading-none">
        {String(index + 1).padStart(2, "0")}
      </div>

      <div className="relative">
        <div className="text-3xl mb-5">{service.icon}</div>
        <h3 className="font-heading text-2xl text-ash-100 tracking-wider mb-3 group-hover:text-ember-400 transition-colors duration-300">
          {service.title}
        </h3>
        <p className="font-body text-ash-500 text-sm leading-relaxed">
          {service.description}
        </p>
      </div>
    </div>
  );
}

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 lg:py-32 bg-carbon-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <AnimatedSection className="mb-16">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-8 h-px bg-ember-400" />
            <span className="font-mono text-xs text-ember-400 tracking-widest uppercase">
              What I Do
            </span>
          </div>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
            <h2 className="font-display text-[clamp(3rem,7vw,6rem)] leading-none tracking-wider text-ash-100">
              SERVICES
            </h2>
            <p className="font-body text-ash-400 max-w-md leading-relaxed">
              End-to-end post-production services for brands, agencies, and
              independent creators.
            </p>
          </div>
        </AnimatedSection>

        {/* Grid */}
        <div className="grid md:grid-cols-2 gap-4">
          {services.map((service, i) => (
            <ServiceCard key={service.title} service={service} index={i} />
          ))}
        </div>

        {/* CTA strip */}
        <AnimatedSection
          className="mt-12 p-8 border border-ember-400/20 flex flex-col md:flex-row items-center justify-between gap-6 bg-carbon-900"
          delay={300}
        >
          <div>
            <p className="font-heading text-2xl text-ash-100 tracking-wider mb-1">
              Have a project in mind?
            </p>
            <p className="font-body text-sm text-ash-500">
              Let's talk about how I can bring your vision to life.
            </p>
          </div>
          <button
            onClick={() =>
              document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })
            }
            className="flex-shrink-0 px-8 py-3.5 bg-ember-400 text-carbon-950 font-heading text-sm tracking-widest uppercase hover:bg-ember-500 transition-all duration-300"
          >
            Get In Touch →
          </button>
        </AnimatedSection>
      </div>
    </section>
  );
}
